import { BenefitParticipationStatus } from 'index'
import { NamedItem } from '../../domain/common/namedItem'
import { adminHttpClient } from '../commons/adminHttpClient'

export type EmployeeDetailsResponse = {
  id: string
  firstName: string
  lastName: string
  workEmail: string
  personalEmail?: string
  receiveSms: boolean
  identificationNumber?: string
  stateOfResidence?: NamedItem
  workPhone?: string
  hireDate?: string
  terminatedDate?: string
  employmentStatus?: NamedItem
  benefitEligibilityDate?: string
  productClass?: NamedItem
  familyStatus?: NamedItem
  shouldDisplayFamilyStatus: boolean
  shouldDisplayBenefitParticipationStatusHistory: boolean
  benefitParticipationStatus: BenefitParticipationStatus
  canBeTerminated: boolean
  canBeEdited: boolean
  birthday?: string
  status: string
  zipCode: string
}

export const getEmployeeDetails = (id: string): Promise<EmployeeDetailsResponse> => {
  return adminHttpClient.get(`/Companies/EmployeeDetails/${id}`)
}
